(<template>
  <div :class="{'wizard-progress--hidden': hideProgress}"
       class="wizard-progress">
    <router-link v-if="prevStep"
                 :to="{name: prevStep}"
                 class="wizard-progress__back-link">
      {{ $gettext('Back') }}
    </router-link>
    <div class="wizard-progress__steps-cont">
      <span v-for="(step, index) in stepsForRender"
            :key="index"
            :class="{'wizard-progress__step--active': step == routeName}"
            class="wizard-progress__step"></span>
    </div>
  </div>
</template>)

<script>
  import {mapState, mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters('UserInfoStore', [
        'currentRole',
        'isEmailVerified'
      ]),
      ...mapState('UserInfoStore', {
        info: ({mainUserInfo}) => mainUserInfo,
        forEnterprise: ({mainUserInfo}) => mainUserInfo.forEnterprise
      }),
      hideProgress() { return this.$route.name == 'WizardChooseRole' || this.$route.name == 'BuyerWizardVerifyEmail'; },
      routeName() { return this.$route.name; },
      interpreterSteps() {
        return [
          'ServerWizardEnterName',
          'ServerWizardEnterPhone'
        ];
      },
      buyerSteps() {
        const stepsList = [
          'BuyerWizardEnterName',
          'BuyerWizardEnterPhone'
        ];
        if (!this.isEmailVerified && this.forEnterprise) {
          stepsList.push('BuyerRegisterEnterprise');
          stepsList.push('BuyerEnterprisePayment');
        }
        return stepsList;
      },
      stepsForRender() {
        switch (this.currentRole) {
          case 'server':
            return this.interpreterSteps;
          case 'buyer':
          case 'employee':
            return this.buyerSteps;
        }
      },
      prevStep() {
        if (this.stepsForRender) {
          for (let i = 0, lim = this.stepsForRender.length; i < lim; i += 1) {
            if (this.stepsForRender[i] == this.routeName && i > 0) return this.stepsForRender[i - 1];
          }
        }
      }
    },
    methods: {
      isPastStep(index) {
        for (let i = 0, lim = this.stepsForRender.length; i < lim; i += 1) {
          if (this.stepsForRender[i] == this.routeName && index < i) return true;
        }
      }
    }
  };
</script>

<style scoped>
  .wizard-progress {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 28px;
    margin: 24px 0;
  }

  .wizard-progress--hidden {
    visibility: hidden;
  }

  .wizard-progress__back-link {
    position: absolute;
    left: 15px;
    padding-left: 15px;
    background: url(~@assets/imgs/arrows/arrow_to_left_black.svg) no-repeat 0 50% / 16px auto;
    font-size: 14px;
  }

  .wizard-progress__steps-cont {
    display: flex;
    width: auto;
  }

  .wizard-progress__step {
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #d0d3dc;
  }

  .wizard-progress__step:not(:last-child) {
    margin-right: 15px;
  }

  .wizard-progress__step--active {
    background-color: var(--color-primary);
  }
</style>
